export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39')
];

export const server_loads = [0];

export const dictionary = {
		"/": [4],
		"/about": [5],
		"/account": [6,[2]],
		"/account/addresses": [7,[2]],
		"/account/orders": [8,[2]],
		"/account/orders/[id]": [9,[2]],
		"/account/profile": [10,[2]],
		"/account/wishlist": [11,[2]],
		"/admin": [12,[3]],
		"/admin/actions": [13,[3]],
		"/admin/categories": [14,[3]],
		"/admin/low-stock": [15,[3]],
		"/admin/notifications": [16,[3]],
		"/admin/orders": [17,[3]],
		"/admin/orders/[id]": [18,[3]],
		"/admin/products": [19,[3]],
		"/admin/products/new": [20,[3]],
		"/admin/products/[id]/edit": [21,[3]],
		"/admin/returns": [22,[3]],
		"/admin/settings": [23,[3]],
		"/auth": [24],
		"/auth/callback": [25],
		"/cart": [26],
		"/checkout": [27],
		"/checkout/success": [28],
		"/contact": [29],
		"/login": [30],
		"/privacy": [31],
		"/products/[slug]": [~33],
		"/product/[slug]": [~32],
		"/refund": [34],
		"/shipping": [35],
		"/shop": [36],
		"/signup": [37],
		"/terms": [38],
		"/wishlist": [39]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';